const { audienceUrl, basePath, apiBaseUrl } = JSON.parse(
  document.getElementById("__PLAYER_UI_DATA__").textContent
);
const managedPlusUrl = `${apiBaseUrl}/managed_plus`;

export { audienceUrl, managedPlusUrl, basePath };
